import type { FormTarget } from "@jti/magento";

/**
 * All placement targets that are visible in the shipping form.
 * Used to filter order attributes for fast-forward pre-filling.
 */
export const SHIPPING_FORM_PLACEMENTS: FormTarget[] = [
  "contactDetails_before",
  "contactDetails_after",
  "shippingAddress_before",
  "shippingAddress_after",
  "billingaddress_before",
  "billingaddress_after",
];
